import React, { Component } from "react"
import Loadable from "react-loadable"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import {
  getSplitIOForFeatures,
  me,
  SHOW_UBER_MEMBERSHIP_BENEFITS_MODAL,
  updateInfo,
  setLastActiveVehicleId,
  optInForMarketing
} from "../../v1/actions/user"
import JustForYouCards from "./Dashboard/JustForYoucards"
import { isMobileOnly } from "react-device-detect"
import { CLEARCOVER, EBAY } from "../../v1/constants/affiliations"
import ShopOrderRatingModal from "../../v1/components/Ratings/ShopOrderRatingModal"
import { convertToLowerCase } from "../../shared_component/utils/stringHelpers"
import SplitClient, {
  EtoB,
  HIDE_SUBSCRIPTION_BASED_ON_USER_AFFILIATION,
  ON,
  setupSplitFlags
} from "../../v1/components/Config/SplitClient"
import { getSubdomain } from "../../v1/components/Config/StylesheetInjector"
import { INSURANCE, TIRE, VSC } from "../../v1/constants/offers"
import { APP_NAME } from "../../shared_component/constants/common"
import { Loader2 } from "../../shared_component/components/Loader2"
import ContentLoader from "../../shared_component/components/ContentLoader"
import {
  gaJSON,
  getRouteNameFromUrl,
  logFirebaseAnalyticsScreenName,
  trackFirebaseAnalytics
} from "../../shared_component/utils/googleAnalyticsHelpers"
import { hasNextMembershipUpgrade } from "../../v1/helpers/membershipHelpers"
import MembershipUpgradeModal2_0 from "./Membership2.0/MembershipUpgradeModal"
import { getJSON } from "../../shared_component/utils/fetch"
import store from "../../shared_component/utils/configureStore"
import FuelcardRequest from "./Dashboard/FuelcardRequest"
import { isEbay, isEbayCart, isUsaa, isUsaaUser } from "../../v1/helpers/affiliationHelpers"
import AffiliationWelcomeModal from "./Affiliations/AffiliationWelcomeModal"
import { WelcomeModalAffiliations } from "../../v1/constants/welcomeModal"
import { setShowWelcomeModal } from "../../v1/actions/common"
import SwitchMap from "./MapBox/SwitchMap"
import { isEmpty } from "lodash"
import TireProtectModal from "./Dashboard/TireProtectModal"
import { routerPaths } from "../../v1/constants/paths"
import { isEbayTireOrder } from "../../v1/helpers/orderHelpers"
import RewardsWelcomeModal from "./Rewards/RewardsWelcomeModal"

const LoadableVehicleDetails = Loadable({
  loader: () => import("./vehicle/VehicleDetails"),
  loading: Loader2
})
const LoadableOffersCards = Loadable({
  loader: () => import("./Dashboard/OffersCard"),
  loading: Loader2
})
class Dashboard extends Component {
  _isMounted = false
  constructor(props) {
    super(props)
    const user = props.user || {}
    const { activeVehicleId, active_carts } = user
    const clearcover = CLEARCOVER,
      isMobileDevice = isMobileOnly
    const modalHideforClearCover =
      convertToLowerCase(user.affiliation_name) == convertToLowerCase(clearcover) && isMobileDevice
        ? false
        : true
    this.state = {
      activeCart: active_carts && active_carts.find((c) => c.vehicle_id == activeVehicleId),
      approvalStatus: null,
      activeVehicleId: props.user.activeVehicleId,
      modalHideforClearCover,
      vscResponse: {},
      insuranceResponse: {},
      tiresResponse: {},
      isLoading: true,
      membershipModalOpen: false,
      isSubscriptionFeatureFlag: null,
      openAffiliationWelcomeModal: false,
      openEtoB: false,
      showTireProtectModal: !user?.marketing_opt_in ?? true,
      openRewardsWelcomeModal: false
    }
  }

  async componentDidMount() {
    this._isMounted = true
    await this.initializeComponent()
    logFirebaseAnalyticsScreenName(getRouteNameFromUrl())
    this.setState({ membershipModalOpen: true })
    const isSubscriptionFeatureFlag = await SplitClient.getTreatments(
      [HIDE_SUBSCRIPTION_BASED_ON_USER_AFFILIATION, EtoB],
      this.props.user,
      { app_name: APP_NAME }
    )
    this.setState({
      isSubscriptionFeatureFlag:
        isSubscriptionFeatureFlag[HIDE_SUBSCRIPTION_BASED_ON_USER_AFFILIATION],
      openEtoB: isSubscriptionFeatureFlag[EtoB] === ON,
      hideTireProtectModal: sessionStorage.getItem("tireProtectModalDisplayed") !== "true"
    })
  }

  async initializeComponent() {
    const { setLastActiveVehicleId } = this.props
    const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true"
    const lastActiveVehicleId = localStorage.getItem("lastActiveVehicleId")
    if (isComparePriceFlow) {
      if ((lastActiveVehicleId?.length || 0) > 0) {
        setLastActiveVehicleId(parseInt(lastActiveVehicleId))
      }
      localStorage.removeItem("isComparePriceFlow")
      localStorage.removeItem("lastActiveVehicleId")
    }
    try {
      await trackFirebaseAnalytics({
        event: gaJSON.dashboard_land
      })
      if (this._isMounted) {
        window.scrollTo(0, 0)
        setupSplitFlags.bind(this)({ sub_domain: getSubdomain(), app_name: APP_NAME })
        this.getSplitIODetails()
      }
    } catch (error) {
      console.log(error)
    }
  }

  async componentDidUpdate() {
    if (this.props.user.active_carts && this.state.isLoading && this.props.user.vehicles) {
      if (this.props.user.vehicles.length && !this.props.user.activeVehicleId) {
        return
      }
      this.setState({ isLoading: false })
    }
    const user = this.props.user
    if (
      user &&
      user.total_shop_orders === 0 &&
      !this.props.order &&
      user.affiliation &&
      WelcomeModalAffiliations.includes(user?.affiliation?.root_reference_id) &&
      !this.state.openAffiliationWelcomeModal &&
      !this.state.hasClosedAffiliationModal &&
      this.state.openEtoB &&
      this.props.showWelcomeModal !== false
    ) {
      this.setState({ openAffiliationWelcomeModal: true })
    }
    if (isEbay() && isEbayTireOrder(this.props.user?.active_carts?.[0])) {
      // if (isEbay() && this.props.user.total_shop_orders === 0) {
      this.props.history.push(routerPaths.selectVehicle)
    }
  }

  closeAffiliationWelcomeModal = () => {
    this.setState({ openAffiliationWelcomeModal: false, hasClosedAffiliationModal: true })
    store.dispatch(setShowWelcomeModal(false))
  }

  closeRewardsWelcomeModal = () => {
    this.setState({ openRewardsWelcomeModal: false })
  }

  closeTireProtectModal = () => {
    this.setState({ showTireProtectModal: false })
    sessionStorage.setItem("tireProtectModalDisplayed", "true")
  }

  componentWillUnmount() {
    this._isMounted = false
  }
  componentWillUnmount() {
    this.setState({ isLoading: true })
  }

  getSplitIODetails = async () => {
    const { getSplitIOForFeatures } = this.props
    const responseVSC = await getSplitIOForFeatures(VSC)
    this.setState({ vscResponse: responseVSC && responseVSC.result })
    const responseInsurance = await getSplitIOForFeatures(INSURANCE)
    this.setState({ insuranceResponse: responseInsurance && responseInsurance.result })
    const responseTires = await getSplitIOForFeatures(TIRE)
    this.setState({ tiresResponse: responseTires && responseTires.result })
  }

  toggleMembershipUpgradeModal = async () => {
    const { updateInfo, user } = this.props
    this.setState({ membershipModalOpen: !this.state.membershipModalOpen })

    const res = await getJSON(
      `/api/v6/affiliations/${user.affiliation.parent_id}/user_promotions`,
      {},
      { Authorization: user.authentication_token }
    )
    const showMembershipModal =
      res.result && res.result.show_membership_benefits
        ? res.result.show_membership_benefits
        : false
    store.dispatch({ type: SHOW_UBER_MEMBERSHIP_BENEFITS_MODAL, payload: showMembershipModal })

    await updateInfo({ send_through_membership_flow: false })
  }

  handleMarketingOptInApi = async (marketingOptIn) => {
    store.dispatch(
      optInForMarketing({
        marketing_opt_in: marketingOptIn,
        closeModal: () => this.closeTireProtectModal()
      })
    )
    sessionStorage.setItem("tireProtectModalDisplayed", "true")
  }

  render() {
    const {
      activeVehicle,
      hasShopOrderToRate,
      t,
      user,
      membershipUpgradeAvailable,
      order
    } = this.props
    const {
      modalHideforClearCover,
      insuranceResponse,
      vscResponse,
      tiresResponse,
      isLoading,
      membershipModalOpen,
      showTireProtectModal,
      hideTireProtectModal
    } = this.state
    const params = new URLSearchParams(this.props.location.search)
    const showRequestCardModel = params.get("RequestFuelCard")
    const vehicleDetails =
      !isEmpty(activeVehicle) && activeVehicle.year && activeVehicle.make && activeVehicle.model
        ? activeVehicle.year + " " + activeVehicle.make + " " + activeVehicle.model
        : "Unknown"

    return (
      <>
        {isLoading ? (
          <ContentLoader />
        ) : (
          <>
            {user &&
              user.send_through_membership_flow &&
              !user.generic &&
              membershipModalOpen &&
              this.state.isSubscriptionFeatureFlag &&
              this.state.isSubscriptionFeatureFlag === ON && (
                <MembershipUpgradeModal2_0
                  isOpen
                  closeModal={this.toggleMembershipUpgradeModal}
                  variableContentType="settingsSection"
                  isDashboardModal="true"
                />
              )}
            <AffiliationWelcomeModal
              openModal={this.state.openAffiliationWelcomeModal}
              closeModal={this.closeAffiliationWelcomeModal}
            />
            <RewardsWelcomeModal
              openModal={this.state.openRewardsWelcomeModal}
              closeModal={this.closeRewardsWelcomeModal}
            />
            {getSubdomain() === EBAY && !user?.marketing_opt_in && (
              <TireProtectModal
                open={showTireProtectModal && hideTireProtectModal}
                onClose={this.closeTireProtectModal}
                marketingOptIn={() => this.handleMarketingOptInApi(true)}
                marketingOptOut={() => this.handleMarketingOptInApi(false)}
                vehicleDetails={vehicleDetails}
              />
            )}

            <div className="dashboard1_5-container">
              {modalHideforClearCover && hasShopOrderToRate && <ShopOrderRatingModal />}

              {/* Will only be rendered for USAA */}
              {user?.id && isUsaaUser(user) && (
                <FuelcardRequest
                  showRequestCardModel={showRequestCardModel}
                  isUsaaUser={isUsaaUser(user)}
                />
              )}

              <LoadableVehicleDetails
                openAffiliationWelcomeModal={this.state.openAffiliationWelcomeModal}
              />
              <div className="dashboard-map-just-for-you">
                <JustForYouCards />
                <div className="dashboard-map-container">
                  <SwitchMap defaultActiveIndex={0} />
                </div>
              </div>
              {user?.country !== "ca" && (
                <div className="dashboard-offers-cards-container">
                  <LoadableOffersCards
                    vscResponse={vscResponse}
                    insuranceResponse={insuranceResponse}
                    tiresResponse={tiresResponse}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </>
    )
  }
}

function mapStateToProps(state) {
  let user = state.user || {}
  const { membershipData } = state
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  let order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let modalNotifications = state.modalNotifications

  return {
    user,
    activeVehicle,
    order,
    isLoggedIn: !!user.authentication_token,
    caradviseCash: state.paymentInfo.caradviseCash,
    hasShopOrderToRate: (user.ratable_shop_order_info || []).length > 0,
    membershipUpgradeAvailable: hasNextMembershipUpgrade(
      user,
      membershipData.availableMembershipPlans
    ),
    showWelcomeModal: state.common.showWelcomeModal
  }
}

export default connect(mapStateToProps, {
  me,
  getSplitIOForFeatures,
  updateInfo,
  setLastActiveVehicleId,
  optInForMarketing
})(withTranslation("dashboardMessage")(Dashboard))
